import React from 'react';
import { Typography } from 'fronton-react';
import { selectWindowType, WindowTypes } from 'store/pageStore';
import { checkScreenType } from 'utils';
import { useSelector } from 'react-redux';
import { ServiceType } from '../../other-services-db';
import { serviceStyles, serviceTypographyStyles } from './styles';

export const Service = ({ name, img, src }: ServiceType) => {
	const screenType = useSelector(selectWindowType);
	const isMobile = checkScreenType(screenType, WindowTypes.mobile);
	return (
		<a href={src} className={serviceStyles}>
			<img src={img} alt="" />
			<Typography
				className={serviceTypographyStyles}
				variant={isMobile ? 'm' : 'l'}
				size="subtitle"
			>
				{name}
			</Typography>
		</a>
	);
};
